import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the designers array
 * @param {string[]} designers - Array of designer strings
 */
export const setDesigners = (designers) => {
  searchPageStore.setState({ designers })
}

/**
 * Adds a designer to the array
 * @param {string} designer - Designer to add
 */
export const addDesigner = (designer) => {
  const state = searchPageStore.getState()
  const currentDesigners = state.designers || []

  if (!currentDesigners.includes(designer)) {
    searchPageStore.setState({ designers: [...currentDesigners, designer] })
  }
}

/**
 * Removes a designer from the array
 * @param {string} designer - Designer to remove
 */
export const removeDesigner = (designer) => {
  const state = searchPageStore.getState()
  const currentDesigners = state.designers || []

  searchPageStore.setState({
    designers: currentDesigners.filter((d) => d !== designer),
  })
}

/**
 * Sets the fully selected designer scopes
 * @param {string[]} designerScopes - Array of scope keys ('following', 'top')
 */
export const setDesignerScopes = (designerScopes) => {
  searchPageStore.setState({ designerScopes })
}

/**
 * Sets both designer slices at once
 *
 * Toggling a scope moves designers between the two slices, and writing them separately would
 * fire a search against the half-applied state and then abort it.
 * @param {string[]} designers - Individually picked usernames
 * @param {string[]} designerScopes - Array of scope keys ('following', 'top')
 */
export const setDesignerSelection = (designers, designerScopes) => {
  searchPageStore.setState({ designers, designerScopes })
}

/**
 * Clears all designers filter
 */
export const clearDesigners = () => {
  searchPageStore.setState({
    designers: DEFAULT_STATE.designers,
    designerScopes: DEFAULT_STATE.designerScopes,
  })
}
